import { render, staticRenderFns } from "./text-inline.vue?vue&type=template&id=54092728&"
import script from "./text-inline.ts?vue&type=script&lang=js&"
export * from "./text-inline.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports